// extracted by mini-css-extract-plugin
export default {"button":"MenuLanguages_button__wtg5Z","buttonMenuLanguages":"MenuLanguages_buttonMenuLanguages__vF+51","ico":"MenuLanguages_ico__P8jFk","root":"MenuLanguages_root__0djpM"};